import { PrometRobeZaKomitentaPoArtiklima } from './promet-robe-za-komitenta-po-artiklima';
import { BaseDataService, NotificationService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { BaseUpdateComponent, BaseContainerService } from 'yt-ng-framework';
// import { NotificationsService } from 'angular2-notifications';
import { ControlContainer, NgForm, Validators } from '@angular/forms';
import { fcall } from 'q';
import { TranslateService } from '@ngx-translate/core';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-promet-robe-za-komitenta-po-artiklima-analitika',
  templateUrl: './promet-robe-za-komitenta-po-artiklima-analitika.component.html'
})
export class PrometRobeZaKomitentaPoArtiklimaAnalitikaComponent
 extends BaseUpdateComponent<PrometRobeZaKomitentaPoArtiklima>
  implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService
  ) {
    super(activatedRoute, baseDataService, toastrService, translateService);
  }

  ngOnInit() {
    super.ngOnInit();
  }

}
